import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  PaymentListReq,
  PaymentListRes,
  CreatePaymentReq,
  ActionPaymentRes,
  UpdatePaymentReq,
  DeletePaymentReq,
  PaymentDetailReq,
  PaymentDetailRes,
  PatialPaymentReq,
  CreateCreditReq,
} from './types'

export const getPaymentListAction = createAsyncAction(
  'PAYMENT/GET_PAYMENT_LIST_REQ',
  'PAYMENT/GET_PAYMENT_LIST_SUCCESS',
  'PAYMENT/GET_PAYMENT_LIST_FAILURE',
)<PaymentListReq, PaymentListRes, Error>()

export const getPaymentDetailAction = createAsyncAction(
  'PAYMENT/GET_PAYMENT_DETAIL_REQ',
  'PAYMENT/GET_PAYMENT_DETAIL_SUCCESS',
  'PAYMENT/GET_PAYMENT_DETAIL_FAILURE',
)<PaymentDetailReq, PaymentDetailRes, Error>()

export const createPaymentAction = createAsyncAction(
  'PAYMENT/CREATE_PAYMENT_REQ',
  'PAYMENT/CREATE_PAYMENT_SUCCESS',
  'PAYMENT/CREATE_PAYMENT_FAILURE',
)<CreatePaymentReq, ActionPaymentRes, Error>()

export const patialPaymentAction = createAsyncAction(
  'PAYMENT/PATIAL_PAYMENT_REQ',
  'PAYMENT/PATIAL_PAYMENT_SUCCESS',
  'PAYMENT/PATIAL_PAYMENT_FAILURE',
)<PatialPaymentReq, ActionPaymentRes, Error>()

export const createCreditNoteAction = createAsyncAction(
  'PAYMENT/CREATE_CREDIT_NOTE_REQ',
  'PAYMENT/CREATE_CREDIT_NOTE_SUCCESS',
  'PAYMENT/CREATE_CREDIT_NOTE_FAILURE',
)<CreateCreditReq, ActionPaymentRes, Error>()

export const updatePaymentAction = createAsyncAction(
  'PAYMENT/UPDATE_PAYMENT_REQ',
  'PAYMENT/UPDATE_PAYMENT_SUCCESS',
  'PAYMENT/UPDATE_PAYMENT_FAILURE',
)<UpdatePaymentReq, ActionPaymentRes, Error>()

export const deletePaymentAction = createAsyncAction(
  'PAYMENT/DELETE_PAYMENT_REQ',
  'PAYMENT/DELETE_PAYMENT_SUCCESS',
  'PAYMENT/DELETE_PAYMENT_FAILURE',
)<DeletePaymentReq, ActionPaymentRes, Error>()

export const clearEventAction = createStandardAction('PAYMENT/CLEAR_EVENT')<void>()
